import React, { Component } from 'react';
import { helpCircleOutline as help, arrowForwardOutline as forward } from 'ionicons/icons';
import {
  IonContent,
  IonHeader,
  IonTitle,
  IonToolbar,
  IonButtons,
  IonBackButton,
  IonButton,
  IonIcon,
  IonList,
  IonItem,
  IonLabel,
  IonCard,
  IonCardHeader,
  IonCardTitle,
  IonCardContent,
  withIonLifeCycle,
} from '@ionic/react';

import ShopServiceService from '../services/shopservice';
import '../theme/service.css';

class Services extends Component {
  constructor(props) {
    super(props);

    this.form = React.createRef();
    this.files = React.createRef();

    this.state = {
      shop_service_id: undefined,
      note: '',
      services: [],
      shopServices: [],
      selectedService: null,
      selectedShopService: null,
      singleCategory: null,
      singleServices: [],
      singleShopServices: [],
    };

    this.setService = this.setService.bind(this);
  }

  async ionViewWillEnter() {
    this.setState({
      id: this.props.id,
      profile: undefined,
      note: '',
      services: [],
      shopServices: [],
      singleCategory: null,
      singleServices: [],
      singleShopServices: [],
    });

    try {
      const response = await ShopServiceService.get();
      const { data } = response.data;

      if (data.length === 1) {
        const category = data[0];
        const detailResponse = await ShopServiceService.find(category.id);
        const { services, shop_service } = detailResponse.data.data;
        this.setState({
          singleCategory: category,
          singleServices: services.filter((s) => s),
          singleShopServices: shop_service.filter((s) => s),
        });
        return;
      }

      this.setState({
        services: data,
      });
    } catch (error) {
      console.error(error);
    }

    if (!!this.props.match.params.id) {
      await this.setService(this.props.match.params.id * 1);
    }
  }

  async setService(id) {
    const selectedService = this.state.services.find((service) => service.id === id);
    this.setState({ selectedService });

    this.props.history.push(`/app/service/category/${id}`);
  }

  render() {
    const { services, singleCategory, singleServices, singleShopServices } = this.state;

    if (singleCategory) {
      const categoryId = singleCategory.id;
      return (
        <>
          <IonHeader>
            <IonToolbar>
              <IonButtons slot="start">
                <IonBackButton defaultHref="/app/home" />
              </IonButtons>
              <IonTitle>Prenota un Servizio</IonTitle>
              <IonButtons slot="end">
                <IonButton href="/app/help/Services">
                  <IonIcon icon={help} />
                </IonButton>
              </IonButtons>
            </IonToolbar>
          </IonHeader>

          <IonContent className="service-list-page">
            <div className="service-list-container">
              <IonCard className="service-list-header" color="light">
                <IonCardHeader>
                  <IonCardTitle>Prenota un Servizio</IonCardTitle>
                </IonCardHeader>
                <IonCardContent>
                  <p>
                    Ecco l'elenco dei nostri servizi,
                    <br />
                    seleziona il servizio che ti interessa
                  </p>
                </IonCardContent>
              </IonCard>

              <div className="service-grid">
                {singleServices.map((service, i) => {
                  const link = `/app/service/category/${categoryId}/${service.id}`;
                  return (
                    <IonCard key={service.id ?? i} className="service-card" onClick={() => this.props.history.push(link)}>
                      <div className="service-card-image">
                        {service.image ? (
                          <img src={service.image} alt={service.name} />
                        ) : (
                          <div className="service-card-image-placeholder">
                            <IonIcon icon={forward} />
                          </div>
                        )}
                      </div>

                      <IonCardHeader>
                        <IonCardTitle>{service.name}</IonCardTitle>
                      </IonCardHeader>

                      <IonCardContent>
                        <p className="service-card-description">
                          <span dangerouslySetInnerHTML={{ __html: service.description }}></span>
                        </p>

                        <div className="service-card-footer">
                          <IonButton
                            className="service-card-button"
                            fill="solid"
                            color="primary"
                            onClick={(e) => {
                              e.stopPropagation();
                              this.props.history.push(link);
                            }}
                          >
                            Prenota
                          </IonButton>

                          <IonIcon icon={forward} color="medium" />
                        </div>
                      </IonCardContent>
                    </IonCard>
                  );
                })}

                {singleShopServices.map((shopService, i) => {
                  const link = `/app/service/category/${categoryId}/shop/${shopService.id}`;
                  return (
                    <IonCard key={`shop-${i}`} className="service-card" onClick={() => this.props.history.push(link)}>
                      <div className="service-card-image">
                        {shopService.image ? (
                          <img src={shopService.image} alt={shopService.name} />
                        ) : (
                          <div className="service-card-image-placeholder">
                            <IonIcon icon={forward} />
                          </div>
                        )}
                      </div>

                      <IonCardHeader>
                        <IonCardTitle>{shopService.name}</IonCardTitle>
                      </IonCardHeader>

                      <IonCardContent>
                        <p className="service-card-description">
                          <span dangerouslySetInnerHTML={{ __html: shopService.description }}></span>
                        </p>

                        <div className="service-card-footer">
                          <IonButton
                            className="service-card-button"
                            fill="solid"
                            color="primary"
                            onClick={(e) => {
                              e.stopPropagation();
                              this.props.history.push(link);
                            }}
                          >
                            Dettagli
                          </IonButton>

                          <IonIcon icon={forward} color="medium" />
                        </div>
                      </IonCardContent>
                    </IonCard>
                  );
                })}
              </div>
            </div>
          </IonContent>
        </>
      );
    }

    return (
      <>
        <IonHeader>
          <IonToolbar>
            <IonButtons slot="start">
              <IonBackButton defaultHref="/app/home" />
            </IonButtons>
            <IonTitle>Prenota un Servizio</IonTitle>
            <IonButtons slot="end">
              <IonButton href="/app/help/Services">
                <IonIcon icon={help} />
              </IonButton>
            </IonButtons>
          </IonToolbar>
        </IonHeader>

        <IonContent>
          <p className="ion-padding-top ion-padding-start ion-padding-end">
            Sfoglia l'elenco delle categorie <br /> e seleziona quella di tuo interesse per accedere ai relativi
            servizi.
          </p>
          <IonList lines="full" className="ion-no-margin ion-no-padding">
            <IonItem>Categorie</IonItem>
            {services.map((service, i) => {
              return (
                <IonItem key={i} onClick={() => this.setService(service.id)}>
                  <IonLabel>{service.name}</IonLabel>
                  <IonIcon slot="end" icon={forward} />
                </IonItem>
              );
            })}
          </IonList>
        </IonContent>
      </>
    );
  }
}

export default withIonLifeCycle(Services);
